import gear from "../assets/images/layouts/sidebar-icons/settings/gear.svg";
import analytic from "../assets/images/layouts/sidebar-icons/analytic/analytic.svg";
import languages from "../assets/images/layouts/sidebar-icons/languages/languages.svg";
import admins from "../assets/images/layouts/sidebar-icons/admins/admin.svg";
import category from "../assets/images/layouts/sidebar-icons/category/category.svg";
import products from "../assets/images/layouts/sidebar-icons/products/product.svg";
import brands from "../assets/images/layouts/sidebar-icons/brands/brands.svg";
import countries from "../assets/images/layouts/sidebar-icons/countries/countries.svg";
import partners from "../assets/images/layouts/sidebar-icons/partners/partners.svg";
import news from "../assets/images/layouts/sidebar-icons/news/news.svg";
import colors from "../assets/images/layouts/sidebar-icons/colors/colors.svg";
import pages from "../assets/images/layouts/sidebar-icons/pages/pages.svg";
import dictionary from "../assets/images/layouts/sidebar-icons/dictionary/dictionary.svg";
import specs from "../assets/images/layouts/sidebar-icons/specs/specs.svg";
import permissions from "../assets/images/layouts/sidebar-icons/permissions/permissions.svg";
import campaign from "../assets/images/layouts/sidebar-icons/campaigns/campaign.svg";
import service from "../assets/images/layouts/sidebar-icons/services/service.svg";
import group_names from "../assets/images/layouts/sidebar-icons/group-names/group_names.svg";
import vacancy from "../assets/images/layouts/sidebar-icons/vacancy/vacancy.svg";
import contact from "../assets/images/layouts/sidebar-icons/contact/contact.svg";
import branchs from "../assets/images/layouts/sidebar-icons/branchs/branchs.svg";
import blogs from "../assets/images/layouts/sidebar-icons/blogs/blogs.svg";
import video from "../assets/images/layouts/sidebar-icons/video/video.svg";
import apply from "../assets/images/layouts/sidebar-icons/repair-order/apply.svg";
import warehouse from "../assets/images/layouts/sidebar-icons/warehouse/warehouse.svg";
import weekly_picks from "../assets/images/layouts/sidebar-icons/weekly_picks/week.svg";
import services_groups from "../assets/images/layouts/sidebar-icons/services_groups/services_groups.svg";
import order_status from "../assets/images/layouts/sidebar-icons/order-status/order_status.svg";
import quick_orders from "../assets/images/layouts/sidebar-icons/quick-orders/quick_orders.svg";
import one_click from "../assets/images/layouts/sidebar-icons/click/one_click.svg";
import about from "../assets/images/layouts/sidebar-icons/about/about.svg";
import official_service from "../assets/images/layouts/sidebar-icons/official_service/official_service.svg";
import chatbot_templates from "../assets/images/layouts/sidebar-icons/chatbot-templates/chatbot_templates.svg";
import live_support from "../assets/images/layouts/sidebar-icons/live-support/live_support.svg";

import gear_active from "../assets/images/layouts/sidebar-icons/settings/gear_active.svg";
import analytic_active from "../assets/images/layouts/sidebar-icons/analytic/analytic_active.svg";
import languages_active from "../assets/images/layouts/sidebar-icons/languages/languages_active.svg";
import admins_active from "../assets/images/layouts/sidebar-icons/admins/admin_active.svg";
import category_active from "../assets/images/layouts/sidebar-icons/category/category_active.svg";
import products_active from "../assets/images/layouts/sidebar-icons/products/product_active.svg";
import brands_active from "../assets/images/layouts/sidebar-icons/brands/brands_active.svg";
import countries_active from "../assets/images/layouts/sidebar-icons/countries/countries_active.svg";
import partners_active from "../assets/images/layouts/sidebar-icons/partners/partners_active.svg";
import news_active from "../assets/images/layouts/sidebar-icons/news/news_active.svg";
import colors_active from "../assets/images/layouts/sidebar-icons/colors/colors_active.svg";
import pages_active from "../assets/images/layouts/sidebar-icons/pages/pages_active.svg";
import dictionary_active from "../assets/images/layouts/sidebar-icons/dictionary/dictionary_active.svg";
import specs_active from "../assets/images/layouts/sidebar-icons/specs/specs_active.svg";
import permissions_active from "../assets/images/layouts/sidebar-icons/permissions/permissions_active.svg";
import campaign_active from "../assets/images/layouts/sidebar-icons/campaigns/campaign_active.svg";
import service_active from "../assets/images/layouts/sidebar-icons/services/service_active.svg";
import group_names_active from "../assets/images/layouts/sidebar-icons/group-names/group_names_active.svg";
import vacancy_active from "../assets/images/layouts/sidebar-icons/vacancy/vacancy_active.svg";
import contact_active from "../assets/images/layouts/sidebar-icons/contact/contact_active.svg";
import branchs_active from "../assets/images/layouts/sidebar-icons/branchs/branchs_active.svg";
import blogs_active from "../assets/images/layouts/sidebar-icons/blogs/blogs_active.svg";
import video_active from "../assets/images/layouts/sidebar-icons/video/video_active.svg";
import apply_active from "../assets/images/layouts/sidebar-icons/repair-order/apply_active.svg";
import warehouse_active from "../assets/images/layouts/sidebar-icons/warehouse/warehouse_active.svg";
import weekly_picks_active from "../assets/images/layouts/sidebar-icons/weekly_picks/week_active.svg";
import services_groups_active from "../assets/images/layouts/sidebar-icons/services_groups/services_groups_active.svg";
import order_status_active from "../assets/images/layouts/sidebar-icons/order-status/order_status_active.svg";
import quick_orders_active from "../assets/images/layouts/sidebar-icons/quick-orders/quick_orders_active.svg";
import one_click_active from "../assets/images/layouts/sidebar-icons/click/one_click_active.svg";
import about_active from "../assets/images/layouts/sidebar-icons/about/about_active.svg";
import official_service_active from "../assets/images/layouts/sidebar-icons/official_service/official_service_active.svg";
import chatbot_templates_active from "../assets/images/layouts/sidebar-icons/chatbot-templates/chatbot_templates_active.svg";
import live_support_active from "../assets/images/layouts/sidebar-icons/live-support/live_support_active.svg";

const sidebar_url_icons = [
  {
    id: "home",
    url_path: "",
    icon: analytic,
    active_icon: analytic_active,
  },
  {
    id: "settings",
    url_path: "settings",
    icon: gear,
    active_icon: gear_active,
  },
  {
    id: "languages",
    url_path: "languages",
    icon: languages,
    active_icon: languages_active,
  },
  {
    id: "admins",
    url_path: "admins",
    icon: admins,
    active_icon: admins_active,
  },
  {
    id: "categories",
    url_path: "categories",
    icon: category,
    active_icon: category_active,
  },
  {
    id: "products",
    url_path: "products",
    icon: products,
    active_icon: products_active,
  },
  {
    id: "brands",
    url_path: "brands",
    icon: brands,
    active_icon: brands_active,
  },
  {
    id: "countries",
    url_path: "countries",
    icon: countries,
    active_icon: countries_active,
  },
  {
    id: "partners",
    url_path: "partners",
    icon: partners,
    active_icon: partners_active,
  },
  {
    id: "news",
    url_path: "news",
    icon: news,
    active_icon: news_active,
  },
  {
    id: "colors",
    url_path: "colors",
    icon: colors,
    active_icon: colors_active,
  },
  {
    id: "pages",
    url_path: "pages",
    icon: pages,
    active_icon: pages_active,
  },
  {
    id: "dictionary",
    url_path: "dictionary",
    icon: dictionary,
    active_icon: dictionary_active,
  },
  {
    id: "category-specs",
    url_path: "category-specs",
    icon: specs,
    active_icon: specs_active,
  },
  {
    id: "permissions",
    url_path: "permissions",
    icon: permissions,
    active_icon: permissions_active,
  },
  {
    id: "campaigns",
    url_path: "campaigns",
    icon: campaign,
    active_icon: campaign_active,
  },
  {
    id: "services",
    url_path: "services",
    icon: service,
    active_icon: service_active,
  },
  {
    id: "category-specs-group-names",
    url_path: "category-specs-group-names",
    icon: group_names,
    active_icon: group_names_active,
  },
  {
    id: "vacancy",
    url_path: "vacancy",
    icon: vacancy,
    active_icon: vacancy_active,
  },
  {
    id: "contact",
    url_path: "contact",
    icon: contact,
    active_icon: contact_active,
  },
  {
    id: "branchs",
    url_path: "branchs",
    icon: branchs,
    active_icon: branchs_active,
  },
  {
    id: "subscribers",
    url_path: "subscribers",
    icon: contact,
    active_icon: contact_active,
  },
  {
    id: "blogs",
    url_path: "blogs",
    icon: blogs,
    active_icon: blogs_active,
  },
  {
    id: "video",
    url_path: "video",
    icon: video,
    active_icon: video_active,
  },
  {
    id: "repair_order",
    url_path: "repair_order",
    icon: apply,
    active_icon: apply_active,
  },
  {
    id: "warehouse",
    url_path: "warehouse",
    icon: warehouse,
    active_icon: warehouse_active,
  },
  {
    id: "weekly_picks_products",
    url_path: "weekly_picks_products",
    icon: weekly_picks,
    active_icon: weekly_picks_active,
  },
  {
    id: "services_groups",
    url_path: "services_groups",
    icon: services_groups,
    active_icon: services_groups_active,
  },
  {
    id: "order_status",
    url_path: "order_status",
    icon: order_status,
    active_icon: order_status_active,
  },
  {
    id: "about",
    url_path: "about",
    icon: about,
    active_icon: about_active,
  },
  {
    id: "accessory_orders",
    url_path: "accessory_orders",
    icon: group_names,
    active_icon: group_names_active,
  },
  {
    id: "quick_orders",
    url_path: "quick_orders",
    icon: one_click,
    active_icon: one_click_active,
  },
  {
    id: "service_orders",
    url_path: "service_orders",
    icon: service,
    active_icon: service_active,
  },
  {
    id: "install_orders",
    url_path: "install_orders",
    icon: service,
    active_icon: service_active,
  },
  {
    id: "product_orders",
    url_path: "product_orders",
    icon: products,
    active_icon: products_active,
  },
  {
    id: "official_service",
    url_path: "official_service",
    icon: official_service,
    active_icon: official_service_active,
  },
  {
    id: "warranty-terms",
    url_path: "warranty-terms",
    icon: official_service,
    active_icon: official_service_active,
  },
  {
    id: "chatbot-templates",
    url_path: "chatbot-templates",
    icon: chatbot_templates,
    active_icon: chatbot_templates_active,
  },
  {
    id: "live-support",
    url_path: "live-support",
    icon: live_support,
    active_icon: live_support_active,
  },
  {
    id: "one_click",
    url_path: "one_click",
    icon: one_click,
    active_icon: one_click_active,
  },
];

export default sidebar_url_icons;
